// Predefiniowane szablony stron per branza dla Lokalnie.pro WYSIWYG buildera.
// Kazdy szablon to lista blokow z placeholder danymi.
// UWAGA: id-ki blokow generowane przy aplikacji szablonu (patrz applyTemplate).

export const TEMPLATE_DEFAULTS = {
  hero: { title: "Twoja firma", subtitle: "Krotki opis dzialalnosci", photo_url: "", use_business_photo: true },
  about: { heading: "O nas", body: "Opisz krotko swoja firme, doswiadczenie, podejscie do klienta." },
  services: { heading: "Nasze uslugi", items: [] },
  why_us: { heading: "Dlaczego warto", items: [] },
  gallery: { heading: "Galeria", photos: [] },
  slotify: { heading: "Zarezerwuj online", subheading: "Wybierz date i godzine wizyty.", slug: "", height: 850 },
  opening: { heading: "Godziny otwarcia" },
  contact: { heading: "Kontakt" },
  map: { heading: "Lokalizacja" },
  cta: { heading: "Skontaktuj sie", subheading: "", button_text: "Zadzwon", button_link: "" },
  whatsapp: { heading: "Napisz do nas na WhatsApp", subheading: "Odpowiemy szybko w godzinach pracy.", phone: "", message: "" },
  testimonials: { heading: "Opinie klientow", items: [] },
  social: { heading: "Znajdz nas w sieci", facebook: "", instagram: "", tiktok: "" },
};

// Builder helper — tworzy blok z unikalnym id-em.
function blk(type, overrides = {}) {
  const base = TEMPLATE_DEFAULTS[type] || {};
  return {
    type,
    data: { ...base, ...overrides },
  };
}

export const TEMPLATES = {
  pusty: {
    label: "Pusty",
    description: "Tylko blok Hero. Buduj od zera.",
    industry: "Brak",
    blocks: [
      blk("hero", { title: "Twoja firma", subtitle: "Krotki opis dzialalnosci" }),
    ],
  },
  "salon-fryzjerski": {
    label: "Salon fryzjerski",
    description: "Hero, cennik strzyzenia, galeria, godziny, kontakt, rezerwacja Slotify.",
    industry: "Fryzjer",
    blocks: [
      blk("hero", { title: "Salon fryzjerski", subtitle: "Strzyzenie, koloryzacja, stylizacja" }),
      blk("services", {
        heading: "Cennik",
        items: [
          "Strzyzenie damskie 100 zl",
          "Strzyzenie meskie 60 zl",
          "Koloryzacja od 180 zl",
          "Balayage od 350 zl",
          "Stylizacja okolicznosciowa 150 zl",
        ],
      }),
      blk("gallery", { heading: "Nasze realizacje" }),
      blk("opening", {}),
      blk("contact", {}),
      blk("slotify", { heading: "Zarezerwuj wizyte online", subheading: "Wybierz fryzjera i wolny termin." }),
    ],
  },
  restauracja: {
    label: "Restauracja",
    description: "Hero, o lokalu, menu, godziny, mapa, kontakt, WhatsApp.",
    industry: "Gastronomia",
    blocks: [
      blk("hero", { title: "Restauracja", subtitle: "Kuchnia regionalna w sercu miasta" }),
      blk("about", { heading: "O nas", body: "Serwujemy dania ze swiezych skladnikow od lokalnych dostawcow. Zapraszamy na sniadania, lunche i kolacje." }),
      blk("services", {
        heading: "Nasze menu",
        items: [
          "Zupa dnia 18 zl",
          "Pierogi ruskie 28 zl",
          "Schabowy z ziemniakami 38 zl",
          "Pstrag z grilla 45 zl",
          "Deser dnia 22 zl",
        ],
      }),
      blk("opening", {}),
      blk("map", {}),
      blk("contact", {}),
      blk("whatsapp", { heading: "Zamow stolik na WhatsApp", subheading: "Odpowiemy w kilka minut." }),
    ],
  },
  "salon-kosmetyczny": {
    label: "Salon kosmetyczny",
    description: "Hero, zabiegi, galeria, opinie, Slotify, kontakt.",
    industry: "Kosmetyka",
    blocks: [
      blk("hero", { title: "Salon kosmetyczny", subtitle: "Pielegnacja twarzy, brwi, dlonie i stopy" }),
      blk("services", {
        heading: "Zabiegi i ceny",
        items: [
          "Oczyszczanie twarzy 180 zl",
          "Mezoterapia iglowa 250 zl",
          "Modelowanie brwi 60 zl",
          "Henna brwi i rzes 80 zl",
          "Manicure hybrydowy 120 zl",
        ],
      }),
      blk("gallery", { heading: "Efekty naszych zabiegow" }),
      blk("testimonials", {
        heading: "Co mowia klientki",
        items: [
          { name: "Anna K.", text: "Bardzo profesjonalna obsluga. Polecam!", rating: 5 },
          { name: "Magdalena W.", text: "Zabieg zgodnie z opisem, efekt rewelacja.", rating: 5 },
        ],
      }),
      blk("slotify", { heading: "Umow zabieg online" }),
      blk("contact", {}),
    ],
  },
  "gabinet-medyczny": {
    label: "Gabinet medyczny",
    description: "Hero, zakres uslug, o lekarzach, godziny, Slotify, kontakt.",
    industry: "Medycyna",
    blocks: [
      blk("hero", { title: "Gabinet medyczny", subtitle: "Konsultacje, badania, profilaktyka" }),
      blk("services", {
        heading: "Zakres uslug",
        items: [
          "Konsultacja internistyczna",
          "USG jamy brzusznej",
          "Badania profilaktyczne",
          "Recepta online",
          "Skierowania na badania",
        ],
      }),
      blk("about", {
        heading: "Nasi lekarze",
        body: "Zespol doswiadczonych specjalistow z wieloletnia praktyka w szpitalach i klinikach.",
      }),
      blk("opening", {}),
      blk("slotify", { heading: "Umow wizyte online", subheading: "Wybierz lekarza i termin." }),
      blk("contact", {}),
    ],
  },
};

// Generates fresh blocks with unique ids by template key.
export function buildBlocksFromTemplate(key) {
  const tpl = TEMPLATES[key];
  if (!tpl) return [];
  return tpl.blocks.map((b, i) => ({
    id: `b_${Date.now().toString(36)}_${i}_${Math.random().toString(36).slice(2, 6)}`,
    type: b.type,
    data: { ...b.data },
  }));
}
